/*LIBRARY*/
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

/*COMPONENT*/
import CheckBoxNew from "../common_input/CheckBoxNew";

/*REDUX*/
import { editLayerForm } from "../../App/actions/layerActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import domain_list from "../../Data/domain_list";

/*CONST*/

const EditGeneral = ({ geo_layer: initial_geo_layer, toggle_edit_general }) => {
  const [geo_layer, set_geo_layer] = useState({});

  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (initial_geo_layer) {
      set_geo_layer(initial_geo_layer);
    }
  }, [initial_geo_layer]);

  const handle_change_layer = (e) => {
    const { target } = e;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    set_geo_layer((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handle_toggle_general = (name) => () => {
    set_geo_layer((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const handle_edit_layer = () => {
    const {
      _id,
      name,
      description,
      is_form_login_req,
      isPublic,
      show_only_highlight_field,
      isGlobalStyle,
      isFormPublic,
      isLocationChangeable,
      isExpand,
      properties,
      /*Tambahan by value */
      picture_url,
      valueStyleProps,
      globalStyleMode,
      valueStyleList,
      isCustomFormMessage,
      customFormMessageHeader,
      customFormMessageDesc,
      is_survey,
    } = geo_layer;

    const body = {
      geo_layer_id: _id,
      name,
      description,
      isLocationChangeable,
      isExpand,
      properties,
      picture_url,
      valueStyleProps,
      globalStyleMode,
      valueStyleList,
      is_form_login_req,
      isPublic,
      show_only_highlight_field,
      isGlobalStyle,
      isFormPublic,
      isCustomFormMessage,
      customFormMessageHeader,
      customFormMessageDesc,
      is_survey,
    };

    dispatch(editLayerForm(body));
    toggle_edit_general();
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state
  // geo_layer state is mapped above using useState

  //global props
  const { domain } = auth;

  //content
  const domain_temp = domain_list?.[domain]?.form_link;

  let content = null;

  if (geo_layer?._id) {
    content = (
      <div>
        <section
          className="container_flat"
          style={{
            margin: "10px",
            display: "inline-block",
            width: "500px",
            maxWidth: "100%",
            verticalAlign: "top",
            textAlign: "left",
          }}
        >
          <div className="text_bold">{dict["General"][language]}</div>
          <input
            type="text"
            name="name"
            id="name"
            value={geo_layer.name || ""}
            onChange={handle_change_layer}
            data-mapid="changeTitle"
          />
          <textarea
            name="description"
            id="description"
            value={geo_layer.description || ""}
            onChange={handle_change_layer}
            rows="20"
            data-mapid="changeArea"
          />
        </section>
        <section
          className="container_flat"
          style={{
            margin: "10px",
            display: "inline-block",
            width: "500px",
            maxWidth: "100%",
            verticalAlign: "top",
            textAlign: "left",
          }}
        >
          <div className="text_bold">{dict["Form config"][language]}</div>
          <div className="text_inferior" style={{ marginBottom: "10px" }}>
            {
              dict[
                "GEO MAPID is integrated with FORM MAPID, edit form configuration here. You can test the link by click on it, if you set this layer as public form you can just test it without logging in, if not you need to login."
              ][language]
            }
          </div>
          <CheckBoxNew
            text="isLocationChangeable"
            title={dict["Changeable Location"][language]}
            value={geo_layer.isLocationChangeable || false}
            handle={handle_toggle_general("isLocationChangeable")}
          />
          <CheckBoxNew
            text="is_form_login_req"
            title="Required to login"
            value={geo_layer.is_form_login_req || false}
            handle={handle_toggle_general("is_form_login_req")}
          />
          <CheckBoxNew
            text="isFormPublic"
            title={dict["Public Form"][language]}
            value={geo_layer.isFormPublic || false}
            handle={handle_toggle_general("isFormPublic")}
          />
          <div style={{ marginTop: "5px" }}>
            {dict["Link"][language]}:{" "}
            <a
              href={`${domain_temp}${geo_layer.link || ""}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#2196f3" }}
            >
              {`${domain_temp}${geo_layer.link || ""}`}
            </a>
          </div>
          <div className="text_bold" style={{ marginTop: "30px" }}>
            {dict["Closing message"][language]}
          </div>
          <CheckBoxNew
            text="isCustomFormMessage"
            title={dict["Activate closing message"][language]}
            value={geo_layer.isCustomFormMessage || false}
            handle={handle_toggle_general("isCustomFormMessage")}
          />
          <input
            type="text"
            placeholder={dict["Closing message title"][language]}
            name="customFormMessageHeader"
            id="customFormMessageHeader"
            value={geo_layer.customFormMessageHeader || ""}
            onChange={handle_change_layer}
            data-mapid="changeCloseTitle"
          />
          <textarea
            rows="5"
            placeholder={dict["Closing message subtitles"][language]}
            name="customFormMessageDesc"
            id="customFormMessageDesc"
            value={geo_layer.customFormMessageDesc || ""}
            onChange={handle_change_layer}
            data-mapid="changeCloseTitleDeskription"
          />
          <button
            type="button"
            onClick={handle_edit_layer}
            className="button background_black"
            data-mapid="clickSimpan"
          >
            {dict["Save"][language]}
          </button>
        </section>
      </div>
    );
  }

  return content;
};

export default EditGeneral;
